<!--
 * @Author: your name
 * @Date: 2021-02-25 14:16:29
 * @LastEditTime: 2021-02-25 16:11:41
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \aioc-vue\src\components\index\expert.vue
-->
<template>
<div class="expert">
    <div class="expert-wrap type-page">
        <h1>项目专家委员会<br /><span>Project Expert Committee</span></h1>
        <ul class="clearfix">
            <li
                v-for="item of expertList"
                :key="item.id"
            >
                <div class="expert-pic"><img :src="item.photo" alt="" ></div>
                <div class="expert-info ">
                   <h2><span>{{item.position}}</span><span>{{item.name}}</span></h2>
                    <p>{{item.intro}}</p>
                </div>
            </li>
        </ul>
  </div>
</div>
</template>

<script>
export default {
    props:['expertList'],
     data() {
        return {
        }
  },
   mounted() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.expert {
   background-color: #fff;
}
.expert-wrap {
    padding: 20px 0 60px;
    h1 {
        text-align: center;
        font-weight: bold;
        margin: 40px 0;
        span {
            font-size: 12px;
            color: #ccc;
        }
    }
    li {
        width: 49%;
        padding: 0 20px;
        float: left;
        margin-top: 30px;
        .expert-pic {
            float: left;
            width: 160px;
            height: 160px;
            border-radius: 100%;
            padding: 10px;
            background-color: #fff;
            overflow: hidden;
            box-shadow: 2px 0px 15px rgba(0,0,0,.1);
             img {
                 width: 140px;
                 height: 140px ;
                 border-radius: 100%;
            }
        }
        .expert-info {
            float: left;
            margin-left: 20px;
            width: 65%;
            height: 100px;
            margin-top: 40px;
            h2 {
                font-size: 18px;
                color: #4165FF;
                font-weight: bold;
                line-height: 30px;
                span:last-child {
                    color: #000;
                    margin-left: 30px;
                }
            }
            p {
                color: #666;
                font-size: 16px;
            }
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/components/index/expert.vue